export default function isPaymentPaid({ next, store }) {
  const { TRANSACTION: { status } } = store.state;

  if (!['SUCCESS', 'REFUND_SUCCESS', 'REFUND_PROCESSING'].includes(status)) {
    return next({ name: 'service.error' });
  }

  return next();
}
